import DeleteAPIWithInstancesModal from './DeleteAPIWithInstancesModal.container';

export default DeleteAPIWithInstancesModal;
